<template>
<div class="chapter">
<div class="inner_page">
<p><a id="c03"></a></p>
<div class="ct sgc-1">
    3
  </div>
<div class="tx1">
    Having just drifted off to sleep, the startled boy jumped to his feet. He quickly looked to either side of him, and there—gasping for breath—was Yi Sobang, hobbling toward him with the aid of a wooden crutch.
  </div>
<div class="tx">
    “Yi Sobang,” the boy cried. Seeing the man, he felt happy, and also hungry.
  </div>
<div class="tx">
    “So this is where you’ve been. I’ve been searching all over for you, boy.”
  </div>
<div class="tx">
    Leaning heavily on his crutch, Yi Sobang looked affectionately at Ch’otchae. The shadows of the man and boy stretched far down to the base of the mountain. With a grunt Ch’otchae lifted his load of wood onto his back.
  </div>
<div class="tx">
    “You were looking for me?”
  </div>
<div class="tx">
    “You bet I was. The sun’s going down already! Now, listen to me, no more talking back like that to your mother.”
  </div>
<div class="tx">
    Ch’otchae laughed sweetly, as he walked side by side with Yi Sobang. 
     The strong light of the low sun was so blinding it was hard to tell if it was morning or sunset.
  </div>
<div class="tx">
    “Your mother cooked rice, you know. She’s been waiting all day for you.”
  </div>
<div class="tx">
    Yi Sobang kept mentioning his mother so that the boy’s anger toward her might subside.
  </div>
<div class="tx">
    “She made rice?” asked the boy. Stopping in his tracks, Ch’otchae looked over at Yi Sobang, and then stared into the distant paddies, lost in his thoughts. In the light of the setting sun the fields look as soft as silk.
  </div>
<div class="tx">
    “Yi Sobang, I sure hope I can start working in the fields this year.”
  </div>
<div class="tx">
    Yi Sobang felt the boy’s words pierce his heart. How can he want to work in the fields? He’s just a boy, he thought. But he remembered how he himself, long ago, had been just as anxious to start working. Yi Sobang let out a deep sigh, staring out at Mount Pult’a with vacant eyes.
  </div>
<div class="tx">
    “I can be out weeding, Yi Sobang, and you could bring me lunch in the fields. . . And then . . .”
  </div>
<div class="tx">
    The boy was all smiles, happy just to talk about it. “And just what fields do you have to weed?” thought Yi Sobang, suppressing the impulse to speak his mind right then and there. Something surged up uncomfortably inside him.
  </div>
<div class="tx">
    “Then you won’t have to go out begging any more, ’cause you can eat the rice that I grow in the fields . . .”
  </div>
<div class="tx">
    Yi Sobang stopped short in his tracks, and leaned heavily on his crutch. In all likelihood he had never in his entire life been touched so deeply. He had certainly never resented this heartless world so much as he did now. A servant ever since he’d been a child, he had suffered every kind of abuse until finally he’d had his leg broken. But, oh! How could any of that matter given what the boy had just said?
  </div>
<div class="tx">
    Ch’otchae, meanwhile, continued to talk with excitement as he walked along, then turned to find that Yi Sobang wasn’t following him any more.
  </div>
<div class="tx">
    “Yi Sobang, why are you crying?”
  </div>
<div class="tx">
    Wide-eyed, Ch’otchae walked back toward the man. Yi Sobang wiped away his tears, then he set his crutch back into motion.
  </div>
<div class="tx">
    “Mom said something to you again, didn’t she? Let’s just kick her out of the way!”
  </div>
<div class="tx">
    The boy’s eyes flashed with anger. Yi Sobang, shocked by his words, stared back at Ch’otchae. Could he still be angry about the fight they’d had earlier? Why else would the child be so hateful towards his own mother?
  </div>
<div class="tx">
    “Ch’otchae, don’t let me hear you talk like that again.”
  </div>
<div class="tx">
    As he spoke Yi Sobang wondered if the boy already sensed something about his mother’s bad behavior. He thought of the men who visited her: Yu Sobang,<span href="#/Text/kang_9781558616530_oeb_ftn_r1#FTN-1" id="Ref-FTN-1" title="Link target outside of Sample"><sup>a</sup></span> Yongsu and then the blacksmith who’d also been coming by recently. Yi Sobang lost the courage to speak any further.
  </div>
<div class="tx">
    The two entered a narrow path along the bank of a wheat field.
  </div>
<div class="tx">
    “Yi Sobang, how much money did you earn today?”
  </div>
<div class="tx">
    The man had the courage to take on this one.
  </div>
<div class="tx">
    “Come on, boy, what money? There was a party over at the tavern today. I stayed there all day long, and only just got back.”
  </div>
<div class="tx">
    “A party . . ? So you brought back rice cakes, didn’t you? You brought back rice cakes!”
  </div>
<div class="tx">
    Tapping his stick on the ground, he stared up at Yi Sobang.
  </div>
<div class="tx">
    “Yeah, I brought some back with me.”
  </div>
<div class="tx">
    “How many?”
  </div>
<div class="tx">
    The boy licked his lips and moved up closer to the man.
  </div>
<div class="tx">
    “Not too many.”
  </div>
<div class="tx">
    “You didn’t give them to Mom again, did you?”
  </div>
<div class="tx">
    “No, I still have them,” he replied, not wanting to disappoint the boy, but fully aware of the nervous twitch in his own eye.
  </div>
<div class="tx">
    “Yi Sobang, wouldn’t it be great if all we had to eat was rice cakes?”
  </div>
<div class="tx">
    The boy’s mouth was watering.
  </div>
<div class="tx">
    “This spring I’ll bring you so many rice cakes your stomach will explode! How about that?”
  </div>
<div class="tx">
    Ch’otchae laughed and struck a few rocks on the ground with his stick. At times like this, when the boy lowered his eyes, he looked more lovable than ever.
  </div>
<div class="tx">
    They arrived home in the dim light of dusk. Ch’otchae’s mother was standing outside the front door when she saw them coming.
  </div>
<div class="tx">
    “Why can’t a tiger carry off that little brat!”
  </div>
<div class="tx">
    She spoke without thinking, and was horrified by what she’d just said. How long she had waited for the boy to come home, and now these nasty words escaped her lips.
  </div>
<div class="tx">
    Ch’otchae let down his load of wood and sprang back up on his feet.
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// kang_9781558616530_oeb_c03_r1.vue?6b9a53f0